import { render, staticRenderFns } from "./EditOrganization.vue?vue&type=template&id=299b0e25&scoped=true&"
import script from "./EditOrganization.vue?vue&type=script&lang=js&"
export * from "./EditOrganization.vue?vue&type=script&lang=js&"
import style0 from "./EditOrganization.vue?vue&type=style&index=0&id=299b0e25&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b0e25",
  null
  
)

export default component.exports